import { Injectable } from '@angular/core';
import { AuthStore } from '@store';
import { BaseApiPickerImpl } from '../base.api-picker';

import { InvitationsApi } from './invitations.api';

@Injectable({ providedIn: 'root' })
export class InvitationsApiPicker extends BaseApiPickerImpl<InvitationsApi> {
  constructor(
    protected authStore: AuthStore,
    protected realApi: InvitationsApi,
    protected mockApi: InvitationsApi // replace with InvitationsMockApi at some point
  ) {
    super(authStore, realApi, mockApi);
  }
}
